module.exports = __webpack_public_path__ + "static/media/m17.b2488dce.jpg";